module.exports = __webpack_public_path__ + "img/handwerk.d794563.jpg";